// extracted by mini-css-extract-plugin
export var contrastLow = "_redotech-redo-web-src-link-contrast-low";
export var externalLink = "_redotech-redo-web-src-link-external-link";
export var externalLinkIcon = "_redotech-redo-web-src-link-external-link-icon";
export var link = "_redotech-redo-web-src-link-link";
export var linkLabel = "_redotech-redo-web-src-link-link-label";